import Store from "@/store";
import { setI18nLanguage } from "../i18n";

export const beforeEachGuard = (to, _from, next) => {
  setI18nLanguage(Store.getters["user/getActiveLocale"]);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!Store.getters["user/userIsLogged"]) {
      next({ name: "auth.login" });
      return;
    }
    const requiredRoleRecord = to.matched.find(
      (r) => r.meta.requiredRole != null
    );
    const requiredRole = requiredRoleRecord?.meta.requiredRole;
    if (requiredRole == null || requiredRole <= 0) {
      next();
      return;
    }
    const userRole = Store.getters["user/getUserRole"];
    if (userRole <= requiredRole) {
      next();
    } else {
      next({ name: "auth.login" });
    }
  } else {
    next();
  }
};

export const afterEachGuard = (to) => {
  Store.dispatch("header/resetState");
  Store.dispatch("businessPlan/resetState");

  if (!to.meta.store || !to.meta.store.keepWorkbook) {
    Store.dispatch("workbook/resetState");
  }
};
